import React, {useEffect} from 'react';
import { useStyles } from "./styles/EduContentsControlStyle";
import {
    Box, FormControl, MenuItem, Select, Typography,
} from "@material-ui/core";
import clsx from "clsx";
import {inject, observer} from "mobx-react";
import {ReactComponent as ArrowDownIcon} from "../../../../common/images/ArrowDownIcon.svg";

function EduContentStepDaySelection (props) {
    const {stepValue, dayValue,setStepValue,setDayValue} = props;
    const classes = useStyles();
    const StepList = Array.from(Array(21));
    const DayList = Array.from(Array(21));

    const handleChangeStepValue = (e) => {
        setStepValue(e.target.value);
    }
    const handleChangeDayValue = (e) => {
        setDayValue(e.target.value);
    }

    const stepMenuItems = () => {
        return StepList.map((key,index) => (
            <MenuItem key={index} value={index + 1}>{index + 1}</MenuItem>
        ))
    }
    const dayMenusItems = () => {
        return DayList.map((key,index) => (
            <MenuItem key={index} value={index}>{index === 0 ? '전체' : index}</MenuItem>
        ))
    }

    useEffect(() => {
        return () => {
            setStepValue(1);
            setDayValue(1);
        };
    }, [setStepValue, setDayValue]);


    return (
        <>
            <Typography className={classes.textStyle}>Step</Typography>
            <FormControl className={classes.formControl}>
                <Select
                    value={stepValue}
                    onChange={handleChangeStepValue}
                    IconComponent={(props) => (
                        <Box>
                            <ArrowDownIcon  {...props} />
                        </Box>
                    )}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right"
                        },
                        transformOrigin:{
                            vertical: 'top',
                            horizontal: 'right',
                        },
                        getContentAnchorEl: null,
                        className:classes.selectPopover
                    }}
                >
                    {stepMenuItems()}

                </Select>
            </FormControl>
            <Typography className={clsx(classes.textStyle, classes.marginLeft30)}>Day</Typography>
            <FormControl className={classes.formControl}>
                <Select
                    value={dayValue}
                    onChange={handleChangeDayValue}
                    IconComponent={(props) => (
                        <Box>
                            <ArrowDownIcon  {...props} />
                        </Box>
                    )}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right"
                        },
                        transformOrigin:{
                            vertical: 'top',
                            horizontal: 'right',
                        },
                        getContentAnchorEl: null,
                        className:classes.selectPopover
                    }}
                >
                    {dayMenusItems()}

                </Select>
            </FormControl>
        </>

    )
}

export default
    inject('contentStore')(
        observer(EduContentStepDaySelection)
    );
